import React, { useEffect, useState } from 'react';
import AttachedUsersFor from './AttachedUsersFor';
import GroupSpecificSetting from './GroupSpecificSetting';
import UserGroupInfo from './UserGroupInfo';
import UserGroupsGridInfoTable from './UserGroupsGridInfoTable';
import { getListAdminGroup, getListUserGroup } from '../../../axios/Group/GroupUrlApi'
import { useTranslation } from 'react-i18next';
import { LoadingProvider, useLoading } from '../../../context/LoadingContext';
import { getUserList } from '../../../axios/User/UserApi';
import { getListEntitieById } from '../../../axios/Setting/SettingUrlApi';
import { toast } from 'react-toastify';
import { useRefresh } from '../../../context/RefreshContext';

const UserGroups = () => {
   const { refreshData, handleRefreshData } = useRefresh();
   const { t } = useTranslation()
   const [statusAddGroup, setStatusAddGroup] = useState(false);
   const [show, hide] = useLoading();
   const [refresh, setRefresh] = useState(false);
   const [refreshInfo, setRefreshInfo] = useState(false);
   const [selectedRow, setSelectedRow] = useState({});
   const [userGroup, setUserGroup] = useState([]);
   const [adminGroup, setAdminGroup] = useState([]);
   const [selectedRows1, setSelectedRows1] = useState({
      groupCode: '',
      groupDescription: '',
      groupMember: [],
      devices: [],
      location: [
         // {
         //    locationName: 'MOBILE-ID',
         //    description: 'Company',
         //    address: '20 Đặng Tiến Đông, An Phú, Thành phố Thủ Đức, Thành phố Hồ Chí Minh',
         //    latitude: '10,808193',
         //    longitude: '106,752741',
         //    radius: 100,
         //    allowByPass: true,
         // },
         // {
         //    locationName: 'MOBILE-ID1',
         //    description: 'Home',
         //    address: '19 Đặng Tiến Đông, An Phú, Thành phố Thủ Đức, Thành phố Hồ Chí Minh',
         //    latitude: '10,808194',
         //    longitude: '106,752742',
         //    radius: 200,
         //    allowByPass: false,
         // },
      ],
   });

   const getStatusAddNewGroup = (status) => {
      setStatusAddGroup(status);
   };

   const handleRowDoubleClick = (employee) => {
      setSelectedRow(employee);
   };

   const [allUser, setAllUser] = useState([]);

   useEffect(() => {
      const fetchUser = async () => {
         try {
            const payload = {
               statusId: 1,
               page: 1,
               pageSize: 500,
               status: true,
               langId: localStorage.getItem("i18nextLngId")
            }
            const response = await getUserList(payload);
            const usersList = response.data.data;
            setAllUser(usersList);
         } catch (error) {
            if (error.response) {
               if (error.response.status !== 401) {
                  toast.error(t(error?.response.data));
               }
            } else {
               toast.error(t('common.network-timeout'));
            }
         }
      };
      fetchUser();

   }, []);

   const handleRefreshTable = () => {
      setRefresh((prev) => !prev);
   };

   const handleRefreshInfo = () => {
      setRefreshInfo((prev) => !prev);
   };

   useEffect(() => {
      const fetchData = async () => {
         const payload = {
            group: selectedRow?.id,
            pageNo: 1,
            recordPerPage: 50000,
            langId: localStorage.getItem("i18nextLngId")
         }
         show()
         try {
            const response = await getListUserGroup(payload);
            setUserGroup(response.data.data)

         } catch (error) {
            if (error.response) {
               if (error.response.status !== 401) {
                  toast.error(t(error?.response.data.message));
               }
            } else {
               toast.error(t('common.network-timeout'));
            }
         } finally {
            hide()
         }
      };
      if (selectedRow?.id) {
         fetchData();
      }
   }, [selectedRow, t, refreshInfo]);

   useEffect(() => {
      const fetchDataAdmin = async () => {
         const payload = {
            group: selectedRow?.id,
            langId: localStorage.getItem("i18nextLngId")
         }
         show()
         try {
            const response = await getListAdminGroup(payload);
            setAdminGroup(response.data.data)

         } catch (error) {
            if (error.response) {
               if (error.response.status !== 401) {
                  toast.error(t(error?.response.data));
               }
            } else {
               toast.error(t('common.network-timeout'));
            }
         } finally {
            hide()
         }
      };
      if (selectedRow?.id) {
         fetchDataAdmin();
      }
   }, [selectedRow, t, refreshInfo]);

   // const handleRowSelection = (newSelection) => {
   //    setSelectedRows1(newSelection);
   //    // setSelectedRow(newSelection);
   // };



   return (
      <div className='user-groups'>
         <div className='grid grid-cols-12 gap-x-5 gap-y-5 items-stretch'>
            <div className='col-span-12 2xl:col-span-6 flex'>
               <div className='card px-3 py-3 w-full h-full'>
                  <LoadingProvider>
                     <UserGroupsGridInfoTable onRowClick={setSelectedRow} onRowDoubleClick={handleRowDoubleClick} refreshData={refreshData} handleRefreshTable={handleRefreshData} userData={allUser} getStatusAddNewGroup={getStatusAddNewGroup} statusAddGroup={statusAddGroup} />
                  </LoadingProvider>
               </div>
            </div>
            <div className='col-span-12 2xl:col-span-6 flex'>
               <div className='w-full h-full'>
                  <LoadingProvider>
                     <UserGroupInfo
                        info={selectedRow}
                        refreshData={refreshData}
                        adminGroup={adminGroup}
                        userGroup={userGroup}
                        handleRefreshTable={handleRefreshData}
                        userData={allUser}
                        refreshInfo={refreshInfo}
                        handleRefreshInfo={handleRefreshInfo}
                        getStatusAddNewGroup={getStatusAddNewGroup}
                     />
                  </LoadingProvider>
               </div>
            </div>
         </div>
      </div>
   );
};

export default UserGroups;
